var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls144(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 237,
    viewBox: "0 0 63 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2012 18.8343L31.2368 36.7192L0.253418 18.8438L31.2368 0.977783L62.2012 18.8343Z",
    fill: "url(#paint0_linear_724_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2011 18.8438V218.567L31.2178 236.433L31.2367 36.7192L62.2011 18.8438Z",
    fill: "#F3F6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2179 236.433L0.253418 218.557V18.8438L31.2368 36.7192L31.2179 236.433Z",
    fill: "url(#paint1_linear_724_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_724_2",
    x1: 62.1972,
    y1: 18.8474,
    x2: 0.249637,
    y2: 18.8474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_724_2",
    x1: 31.2327,
    y1: 127.642,
    x2: 0.249636,
    y2: 127.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls144);
export default __webpack_public_path__ + "static/media/ils_14_4.f5435af0e75e599ed0a754fb7f514139.svg";
export { ForwardRef as ReactComponent };